module.exports = __webpack_public_path__ + "img/autoinvestment.7310d298.svg";